<template>
  <div id="wiatting-for-upload" class="container-sm">
    <ordering-bread :order-status="order.order_status"></ordering-bread>

    <div class="page-content">
      <ordering-step :order="order" :current-page-order-status="1"></ordering-step>

      <ordering-order-basic-info
        v-if="order.user_order_id"
        :order="order"
        @changeDepartDate="changeDepartDate"
      ></ordering-order-basic-info>

      <div class="center-content">
        <div class="applicant-list">
          <div class="applicant-list-header">
            <div class="header-left">
              <div class="applicant-length">
                申请人
                <span>(共{{order.applicant && order.applicant.length}}人)</span>
              </div>
              <!--
                添加申请人按钮显示条件：
                1、当前订单内申请人数量小于 最大数量（普通订单为200，飞猪订单为飞猪下单商品数量）；
                2、飞猪线上订单不能添加申请人
              -->
              <div class="applicant-add" @click="addApplicant" v-if="order.applicant && (order.ota_info ? order.applicant.length < order.ota_info.item_num : order.applicant.length < 200) && !isOtaOnline">
                <img src="../../assets/imgs/order/icon-add.png">添加
              </div>
            </div>
            <div class="header-right">
            </div>
          </div>
        </div>
        <ordering-upload-applicant-item
          v-for="(applicant, index) in order.applicant"
          :key="index"
          :order="order"
          :applicant="applicant"
          :productData="productData"
          :is-first="index === 0"
          @applicantDelete="applicantDelete"
          @updateApplicant="getOrder"
          >
        </ordering-upload-applicant-item>
        <div class="button-area">
          <div class="step-button" @click="uploadComfirm">
            <img src="../../assets/imgs/application/next-step.png">
            <span>下一步</span>
          </div>
        </div>
      </div>
    </div>

    <add-order
      :open="bookingModal"
      :product="dataModel"
      :productData="productData"
      :order.sync="order"
      :country-id="dataModel.visa_country_id"
      :country-url="dataModel.website_bkg_img || dataModel.national_flag_img"
      :hideDate="true"
      :wiattingForUploadAddApplicant="wiattingForUploadAddApplicant"
      @refreshApplicantList="refreshApplicantList"
      @modalClose="bookingModal = false"
      :is-ota="isOta"
      :otaItemNum="order.ota_info ? order.ota_info.item_num : 200"
    ></add-order>

    
  </div>
</template>

<script>
import addOrder from '@/components/add-order/add-order';
import utils from '../../libs/utils';

import orderingService from '../../services/ordering-service';
import addNewOrderService from '../../services/add-new-order-service';
import orderConstants from '../../constants/order-constants';

import orderingBread from './components/ordering-bread';
import orderingStep from './components/ordering-step';
import orderingOrderBasicInfo from './components/ordering-order-basic-info';
import deleteApplicantId from './components/delete-applicant-id';

// import insurancePopup from '../businessInsurance/popupBox/index';
import orderingUploadApplicantItem from './components/ordering-upload-applicant-item';


export default {
  name: 'wiatting-for-upload',
  data() {
    return {
      orderId: +this.$route.params.oid,
      go_next_step: this.$route.query.go_next_step, // 只有从资料上传页面回来的时候会带上这个query, 需要是否所有申请人已经上传完成所有资料,如果是,下一步
      order: {},
      dataModel: {}, // 订单对应的商品数据
      bookingModal: false,
      productData: null,
      addMode: false,
      wiattingForUploadAddApplicant: {},
      isOta: false, // 是否是ota订单
      isOtaOnline: false, // 是否是OTA线上订单
    };
  },
  components: {
    orderingBread,
    orderingStep,
    orderingOrderBasicInfo,
    deleteApplicantId,
    addOrder,
    addNewOrderService,
    orderingUploadApplicantItem,
  },
  computed: {

    // 是否所有申请人资料都上传完成
    uploadFinished() {
      if (this.order && this.order.applicant) {
        return this.order.applicant.every(applicant => orderingService.getProgress(applicant) === 100);
      }
      return false;
    },
    // 所有申请人申请表是否填完
    applyFinish() {
      // 是否需要申请表
      if (this.order.visa_application_id) {
        if (this.order && this.order.applicant) {
          return this.order.applicant.every(applicant => (applicant.application && applicant.application.application_status === 2));
        }
        return false;
      }
      // 不需要直接返回true
      return true;
    },
  },
  methods: {

    getApplicantAvatarStyle: orderingService.getApplicantAvatarStyle,

    // 删除申请人回调
    applicantDelete(deletedApplicantId) {
      utils.msgbox.confirm('确定要删除该申请人吗？', '删除申请人', {
        confirmButtonText: '　是　',
        cancelButtonText: ' 再想想 ',
        type: 'warning',
      }).then(() => {
        orderingService.deleteApplicant(deletedApplicantId, this.orderId).then(() => {
          this.order.applicant = this.order.applicant.filter(applicant => applicant.order_applicant_id !== deletedApplicantId);
        }).catch((e) => {
          if (e) console.log(e);
        });
        this.$message({
          message: '删除成功',
          type: 'success',
        });
      });
    },
    // 更改选择时间回调
    changeDepartDate(date) {
      this.order.depart_date = date;
    },

    getOrder() {
      orderingService.getOrderData(this.orderId)
        .then((data) => {
          document.title = `${data.country}国家签证办理-上上签同业签证平台，旅游同业签证办理的智能平台`;

          // 判断是否是ota线上订单
          if (data.ota_info && !data.ota_info.ota_offline) {
            this.isOtaOnline = true;
          } else {
            this.isOtaOnline = false;
          }

          // 查询订单对应的商品数据
          orderingService.getProductData(data.visa_product_id).then((data) => {
            this.dataModel = data;
            this.productData = data;
          }).catch((e) => {
            if (e) console.log(e);
          });

          // 判断是否已支付过
          if (data.pay_info && data.pay_info.pay_status > 0) {
            utils.msg.warning('订单已支付');
            return this.$router.replace({ name: 'orderDetail', params: { oid: this.orderId } });
          }

          // 拿到数据
          this.order = utils.extend({}, data);
          // 判断是否是ota订单
          this.isOta = !!(data.ota_info && data.ota_info.ota_order_id);
          // 计算完成度(timeout为了动画)
          setTimeout(() => {
            this.order.applicant.forEach((applicant) => {
              this.$set(applicant, 'finishPercent', orderingService.getProgress(applicant));
            });
          }, 100);

          // 从资料上传页面回来这个页面的时候, 如果带了这个参数, 就看能不能跳转到下一个tab,如果能就跳转
          this.$nextTick(() => {
            if (this.uploadFinished && this.go_next_step && this.applyFinish
                && (this.order.order_status === orderConstants.STATUS.waittingToUploadMaterial_1 || this.order.order_status === orderConstants.STATUS.waittingToWriteApplicantion_2)) {
              this.uploadComfirm();
            }
          });
        }).catch((e) => {
          if (e) console.log(e);
        });
    },

    // 上传确认
    uploadComfirm() {
      if (!this.uploadFinished) {
        return utils.msg.warning('请上传完整资料');
      }
      if (!this.applyFinish) {
        return utils.msg.warning('请填写完整申请表');
      }

      MtaH5.clickStat('uploadnext');
      orderingService.uploadCheck(this.orderId).then(() => {
        orderingService.applicationCheck(this.order.user_order_id).then(() => {
          // 对于资料上传页面来说, 一定有下一步
          const nextRouter = orderingService.getOrderSteps(this.order)[1].routeConfig;
          this.$router.push(nextRouter);
          // if (this.order.product_insurance && this.order.product_insurance.insurance_type === 2 && this.order.order_insurance === undefined && nextRouter.name === 'orderComfirm') {
          //   insurancePopup.show(this.order, this).then((e) => {
          //     if (e) {
          //       this.$router.push(nextRouter);

          //       // 滚到顶部
          //       utils.scrollTop();
          //     }
          //   }).catch((e) => {
          //     if (e) console.log(e);
          //   });
          // } else {
          //   this.$router.push(nextRouter);
          // }

          utils.scrollTop();

        });
      });
    },

    // 添加申请人
    addApplicant() {

      // 遍历该商品配置的身份对应的资料
      this.wiattingForUploadAddApplicant.productData = addNewOrderService.isHavePassportOrIDcard(this.dataModel);
      this.wiattingForUploadAddApplicant.passportOrIDcard = this.wiattingForUploadAddApplicant.productData.passportOrIDcard;
      this.wiattingForUploadAddApplicant.batchUploadElecID = this.wiattingForUploadAddApplicant.productData.batchUploadElecID;

      if (this.wiattingForUploadAddApplicant.passportOrIDcard) {

        // 有护照或身份证时跳转到第二步“手动添加或批量上传”界面
        this.wiattingForUploadAddApplicant.jumpTo = 2;

        // 如果是ota订单，只支持手动上传
        this.wiattingForUploadAddApplicant.jumpTo = 3;
        this.wiattingForUploadAddApplicant.normalOrUpload = false;
      } else {

        // 都没有时跳转到第三步
        this.wiattingForUploadAddApplicant.jumpTo = 3;
        this.wiattingForUploadAddApplicant.normalOrUpload = false;
      }

      this.bookingModal = true;
    },

    // 新增申请人刷新列表
    refreshApplicantList() {
      this.bookingModal = false;
      this.getOrder();
      this.$message({
        message: '申请人添加成功',
        type: 'success',
      });
    },
  },
  created() {
    this.getOrder();
  },
  // destroyed() {
  //   insurancePopup.hide();
  // },
};
</script>

<style lang="less">
@import  '../../assets/less/variable';
#wiatting-for-upload {
  margin-bottom: 100px;
  .page-content {
    box-shadow:0 1px 7px -3px #555;
    .center-content {
      padding:30px 30px 30px 30px;
      background-color: white;
      .common-button {
        position: relative;
      }
      .empty-button {
        background-color: #ffffff;
        color: #5e9be1;
      }
      .applicant-list{
        .applicant-list-header{
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 17px;
          .header-left{
            display: flex;
            align-items: flex-end;
            .applicant-length{
              color: #333333;
              font-size: 18px;
              span{
                color: #999;
                font-size: 14px;
              }
            }
            .applicant-add{
              font-size: 14px;
              line-height: 17px;
              color: #5E9BE1;
              margin-left: 20px;
              cursor: pointer;
              img{
                width: 17.5px;
                height: 17.5px;
                vertical-align: top;
                margin-right: 3px;
              }
            }
          }
          .header-right{
            display: flex;
            align-items: flex-end;
          }
        }
      }
      .button-area {
        padding-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        .step-button {
          cursor: pointer;
          display: flex;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
          }
          span {
            font-size: 14px;
            color: @main;
            margin-left: 10px;
          }
        }

        .step-button + .step-button {
          margin-left: 70px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/WaittingForUpload.vue